import React from "react";
import Image from "../../components/ui/image";
import { Images } from "../../lib/images";

function Features() {
  return (
    <section className="pt-10 pb-16 px-5 bg-background">
      <div className="container mx-auto text-center">
        <h2 className="headingB pb-3">Platform Features</h2>
        <p className="commonTxt">
          Comprehensive football analytics powered by the revolutionary Titan
          Index algorithm
        </p>
        <div className="grid grid-cols-4 gap-5 pt-8">
          <div className="col-span-4 md:col-span-2 lg:col-span-1 bg-white rounded-xl p-5">
            <Image src={Images.Feat1} alt="" className="inline w-20 mb-5" />
            <h4 className="text-lg text-black font-medium pb-2">
              Advanced Analytics
            </h4>
            <p className="commonTxt">
              Deep statistical analysis of club performance, finances, and
              social impact.
            </p>
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 bg-white rounded-xl p-5">
            <Image src={Images.Feat2} alt="" className="inline w-20 mb-5" />
            <h4 className="text-lg text-black font-medium pb-2">
              Titan Index Rankings
            </h4>
            <p className="commonTxt">
              Comprehensive scoring system that ranks football clubs by their
              overall greatness.
            </p>
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 bg-white rounded-xl p-5">
            <Image src={Images.Feat3} alt="" className="inline w-20 mb-5" />
            <h4 className="text-lg text-black font-medium pb-2">
              Club Profiles
            </h4>
            <p className="commonTxt">
              Detailed profiles with historical data, trophies, and performance
              metrics.
            </p>
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 bg-white rounded-xl p-5">
            <Image src={Images.Feat4} alt="" className="inline w-20 mb-5" />
            <h4 className="text-lg text-black font-medium pb-2">
              Performance Tracking
            </h4>
            <p className="commonTxt">
              Monitor club progress over time with interactive charts and
              visualizations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
